import Cell from './Cell';

/**
 *
 */
export default class CellLoader {
    /**
     * @param {string} appResourceField
     * @param {string} header
     * @param {number} colSize
     * @param {{}} config
     * @param {boolean} sortable
     * @param {?string} sortableField
     * @param {?number} headerColSize
     */
    constructor(
        appResourceField, header = '',
        colSize,
        config = {},
        sortable = false,
        sortableField = null,
        headerColSize = null,
        responsiveCols = null
    ) {
        this._appResourceField = appResourceField;
        this._header = header;
        this._colSize = colSize;
        this._config = config;
        this._sortable = sortable;
        this._sortableField = sortableField;
        this._headerColSize = headerColSize;
        this._responsiveCols = responsiveCols;

    }

    /**
     * @return {{}}
     */
    vueComponent() {
        return Cell;
    }

    /**
     * @return {{}}
     */
    props() {
        return {
            content: this.config.content,
            getCurrentValue: this.config.getCurrentValue,
        };
    }

    /**
     * @return {string}
     */
    get appResourceField() {
        return this._appResourceField;
    }

    /**
     * @return {string}
     */
    get header() {
        return this._header;
    }

    /**
     * @return {{}}
     */
    get config() {
        return this._config;
    }

    /**
     * @return {boolean}
     */
    get sortable() {
        return this._sortable;
    }

    /**
     * @return {?string}
     */
    get sortableField() {
        return this._sortableField;
    }

    /**
     * @return {number}
     */
    get colSize() {
        return this._colSize;
    }

    /**
     * @return {number}
     */
    get headerColSize() {
        return this._headerColSize;
    }

    /**
     * @return {?{sm: number, md: number, lg: number}}
     */
    get responsiveCols() {
        return this._responsiveCols;
    }
}

